module.exports = {"version":"1.141.1"}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 1589
// module chunks = 1